import * as Sentry from '@sentry/browser'
import React, { Component } from 'react'
import Headers from 'fetch-headers'
import Media from 'react-media'
import logo from 'assets/images/logo.svg'
import 'react-app-polyfill/stable'

// TODO: merge this file with onboarding entry, then remove

const token = process.env.REACT_APP_OMS_TOKEN

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,
})

interface IProps {
  children: JSX.Element | JSX.Element[]
}

class App extends Component<IProps> {
  public UNSAFE_componentWillMount() {
    const authHeader = new Headers()

    authHeader.append('Authorization', `Basic ${token}`)

    const configInit: RequestInit = {
      cache: 'default',
      headers: authHeader,
      method: 'GET',
    }
  }

  public componentDidCatch(error: any, errorInfo: any) {
    this.setState({ error })
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  public render() {
    const { children } = this.props

    if (!children) {
      return (
        <div className="app">
          <header className="app-header">
            <img src={logo} className="app-logo" alt="logo" />
            <p>
              Edit <code>src/App.tsx</code> and save to reload.
            </p>
            <a
              className="app-link"
              href="https://reactjs.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn React
            </a>
          </header>
        </div>
      )
    }

    return <Media query="(min-width: 0px)" render={() => <div className="app">{children}</div>} />
  }
}

export default App
